module.exports = __webpack_public_path__ + "static/media/FuturaStd-Bold.207f3608.ttf";